import { useResponsiveStyling } from '@akin-home/utils/native';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React from 'react';

export interface DrawerIconProps {
  color: string;
  size: number;
  focused: boolean;
}

// factory function to inject an icon, since the drawer doesn't do it by default.
export const drawerIcon = (icon: IconProp) => (props: DrawerIconProps) => {
  const { ms } = useResponsiveStyling();

  return (
    <FontAwesomeIcon
      size={ms(props.size, 0.35, { min: 20 })}
      icon={icon}
      color={props.color}
    />
  );
};
